import { render, staticRenderFns } from "./wxLoginPage.vue?vue&type=template&id=73e019cd&scoped=true"
import script from "./wxLoginPage.vue?vue&type=script&lang=js"
export * from "./wxLoginPage.vue?vue&type=script&lang=js"
import style0 from "./wxLoginPage.vue?vue&type=style&index=0&id=73e019cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e019cd",
  null
  
)

export default component.exports